import { productCarouselConstants } from '../constants';
import { productCarouselService } from '../../services';

export const productCarouselActions = {
  productCarouselList,
  addProductCarousel,
  getProductCarousel,
  updateProductCarousel,
};

/*
ACTION: Product Carousels List
*/
function productCarouselList(pageID, perPage, searchInput) {
  return (dispatch) => {
    dispatch(request());
    return productCarouselService.productCarouselList(pageID, perPage, searchInput).then(
      (response) => {
        console.log(response.data.body.items);

        dispatch(success(response.data.body.items, response.data.body.data.total));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productCarouselConstants.GETALL_REQUEST };
  }
  function success(items, total) {
    return { type: productCarouselConstants.GETALL_SUCCESS, items, total };
  }
  function failure(error) {
    return { type: productCarouselConstants.GETALL_FAILURE, error };
  }
}

/*
ACTION: Add Product Carousel
*/
function addProductCarousel(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return productCarouselService.addProductCarousel(formData).then(
      (response) => {
        addToast('عملیات با موفقیت انجام شد.', { appearance: 'success', autoDismiss: true });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productCarouselConstants.ADD_REQUEST };
  }
  function success(status) {
    return { type: productCarouselConstants.ADD_SUCCESS, status };
  }
  function failure(error) {
    return { type: productCarouselConstants.ADD_FAILURE, error };
  }
}

/*
ACTION: Get ProductCarousel By ID
*/
function getProductCarousel(addToast, productCarouselID) {
  return (dispatch) => {
    dispatch(request());
    return productCarouselService.getProductCarousel(productCarouselID).then(
      (response) => {
        dispatch(success(response.data.body));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productCarouselConstants.GET_REQUEST };
  }
  function success(item) {
    return { type: productCarouselConstants.GET_SUCCESS, item };
  }
  function failure(error) {
    return { type: productCarouselConstants.GET_FAILURE, error };
  }
}

/*
ACTION: Update ProductCarousel
*/
function updateProductCarousel(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return productCarouselService.updateProductCarousel(formData).then(
      (response) => {
        addToast('بروزرسانی با موفقیت انجام شد.', { appearance: 'success', autoDismiss: true });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: productCarouselConstants.UPDATE_REQUEST };
  }
  function success(status) {
    return { type: productCarouselConstants.UPDATE_SUCCESS, status };
  }
  function failure(error) {
    return { type: productCarouselConstants.UPDATE_FAILURE, error };
  }
}
